import { registerMutation, registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { AUTOMATION_PLATFORM_FLOW_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import * as FlowSourceTypes from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { ACTION_SET } from 'automation-ui-canvas/flow/constants/FlowTypes';
import Action from 'automation-ui-action-features/records/Action';
export const CREATE_BLANK_ACTION_SET_FIELD_NAME = 'actionSetHybridCreate';
export const CREATE_BLANK_ACTION_SET = registerMutation({
  fieldName: CREATE_BLANK_ACTION_SET_FIELD_NAME,
  args: ['name', 'description'],
  fetcher({
    name,
    description,
    objectTypeId
  }) {
    return http.post('automationplatform/v1/hybrid/create', {
      query: {
        sourceApp: SourceApps.WORKFLOWS_APP
      },
      data: {
        name,
        flowType: ACTION_SET,
        objectTypeId,
        description
      }
    });
  }
});
export const CONVERT_TO_ACTION_SET_FIELD_NAME = 'actionSetHybridConvert';
export const CONVERT_TO_ACTION_SET = registerMutation({
  fieldName: 'actionSetHybridConvert',
  args: ['name', 'description', 'sourceFlowId'],
  fetcher({
    name,
    description,
    sourceFlowId
  }) {
    return http.post(`automationplatform/v1/hybrid/convert?sourceApp=${SourceApps.WORKFLOWS_APP}`, {
      data: {
        name,
        description,
        targetFlowType: ACTION_SET,
        sourceFlowId
      }
    });
  }
});
const actionSetsFieldName = 'actionSetsList';
export const GET_ACTION_SETS = registerQuery({
  fieldName: actionSetsFieldName,
  args: ['count', 'flowObjectTypeId', 'idsToOmit', 'offset', 'query'],
  fetcher: ({
    count = 50,
    flowObjectTypeId,
    idsToOmit = [],
    offset = 0,
    query
  }) => {
    const filters = [{
      operator: 'EQ',
      value: 'actionset',
      // TODO - maybe use a const for this
      property: 'hs_flow_type'
    }, {
      operator: 'EQ',
      value: flowObjectTypeId,
      property: 'hs_object_type_id'
    }, {
      operator: 'EQ',
      value: 'false',
      property: 'hs_is_deleted'
    }];
    if (idsToOmit.length) {
      filters.push({
        operator: 'NOT_IN',
        values: idsToOmit,
        property: 'hs_flow_id'
      });
    }
    const data = {
      objectTypeId: AUTOMATION_PLATFORM_FLOW_ID,
      count,
      offset,
      query,
      // TODO - consider limiting properties to reduce payload size
      requestOptions: {
        allPropertiesFetchMode: 'latest_version',
        includeAllProperties: true
      },
      filterGroups: [{
        filters
      }],
      sorts: [{
        property: 'hs_flow_updated_at',
        order: 'DESC'
      }]
    };
    return http.post(`crm-search/search`, {
      data
    });
  }
});
export const actionSetsQueryFieldPolicy = {
  [actionSetsFieldName]: {
    keyArgs: ['count', 'flowObjectTypeId', 'query'],
    merge(existing, incoming) {
      return incoming;
    }
  }
};
export const GET_ACTION_SET_CRM_OBJECT_BY_ID = registerQuery({
  fieldName: 'actionSet',
  args: ['actionSetId'],
  fetcher: ({
    actionSetId
  }) => {
    const data = {
      objectTypeId: AUTOMATION_PLATFORM_FLOW_ID,
      count: 1,
      offset: 0,
      requestOptions: {
        allPropertiesFetchMode: 'latest_version',
        includeAllProperties: true
      },
      filterGroups: [{
        filters: [{
          operator: 'EQ',
          value: actionSetId,
          property: 'hs_flow_id'
        }]
      }]
    };
    return http.post(`crm-search/search`, {
      data
    }).then(({
      results
    }) => results && results.length ? results[0] : null);
  }
});
export const DELETE_ACTION_SET = registerMutation({
  fieldName: 'actionSet',
  args: ['actionSetId'],
  fetcher: ({
    actionSetId
  }) => {
    return http.post(`automationplatform/v1/hybrid/batch-delete?sourceapp=${SourceApps.WORKFLOWS_APP}`, {
      data: {
        flows: [{
          flowId: actionSetId,
          flowSource: FlowSourceTypes.PLATFORM
        }],
        force: true
      }
    });
  }
});
const PROVISIONED_ACTION_SET_FIELD_NAME = 'provisionedActionSet';
const GET_PROVISIONED_ACTION_SET = registerQuery({
  fieldName: PROVISIONED_ACTION_SET_FIELD_NAME,
  args: ['setId', 'sourceFlowId'],
  fetcher({
    setId,
    sourceFlowId
  }) {
    return http.post(`automationplatform/v1/actions/set/${setId}/provision/for/${sourceFlowId}`).then(response => {
      const actions = response.actions.map(actionResponse => new Action(actionResponse));
      return Object.assign({}, response, {
        actions
      });
    });
  }
});
export const useGetProvisionedActionSet = ({
  setId,
  sourceFlowId,
  fetchPolicy = 'network-only'
}) => {
  return useQuery(GET_PROVISIONED_ACTION_SET, {
    variables: {
      setId,
      sourceFlowId
    },
    fetchPolicy
  });
};
export const VALIDATE_ACTION_SET_CONVERSION = registerQuery({
  fieldName: 'actionSetValidation',
  args: ['flowId'],
  fetcher: ({
    flowId
  }) => {
    return http.get(`automationplatform/v1/validation/conversion/flowId/${flowId}/targetFlowType/ActionSet`);
  }
});
export const VALIDATE_ACTION_SET_BY_ID = registerQuery({
  fieldName: 'flowValidation',
  args: ['flowId'],
  fetcher: ({
    flowId
  }) => {
    return http.get(`automationplatform/v1/validation/${flowId}`);
  }
});